<template>
  <div class="virtural-tradeshow">
    <div class="page-wrapper pt-0 pb-0">
      <div class="content-container hero-1">
        <h2 class="text-center-sm">WELCOME TO BULLETIN’S</h2>
        <h2 class="text-center-sm">2022 DISCOVERY EVENT</h2>
        <br />
        <h3 class="p-10-sm text-center">
          We’re bringing together our community of Entrepreneurs,
          <br class="hide-sm" />
          Founders, and Retailers for three days of brand discovery,
          <br class="hide-sm" />
          industry insights, and free shipping!
          <br class="hide-sm" />
          Use code <b>FREESHIPME</b> to get up to $100 of shipping
          <br class="hide-sm" />
          costs covered by Bulletin on all orders.
        </h3>
        <br />
        <a href="/virtual-discovery-show-brand-directory" class="button black-bg color-white">SHOP TODAY’S BRANDS</a>
      </div>
    </div>
    <div id="features" class="pb-30 pt-10 bt bb">
      <div class="container">
        <div class="grid-12">
          <router-link
            :to="{ name: 'winterShowcase', query: { day: '1' } }"
            class="span-4 span-12-sm mb-30-sm text-center px-10 pointer"
          >
            <img src="@/assets/img/home/calendar.svg" class="width-75px unselectable no-events" alt="ribbon-icon" />
            <h4>Day 1</h4>
            <h3 class="bold inline-block"> Exclusive to Bulletin Brands</h3>
            <p class="font-size-18 mt-10"> The brands and products you can’t find anywhere else</p>
          </router-link>
          <router-link
            :to="{ name: 'winterShowcase', query: { day: '2' } }"
            class="span-4 span-12-sm mb-30-sm text-center px-10 pointer"
          >
            <img src="@/assets/img/home/calendar.svg" class="width-75px unselectable no-events" alt="hearts-icon" />
            <h4>Day 2</h4>
            <h3 class="bold inline-block"> Brands on the Rise</h3>
            <p class="font-size-18 mt-10"> Shelf-worthy brands that have flown under the radar... until now</p>
          </router-link>
          <router-link
            :to="{ name: 'winterShowcase', query: { day: '3' } }"
            class="span-4 span-12-sm text-center px-10  pointer"
          >
            <img src="@/assets/img/home/calendar.svg" class="width-75px unselectable no-events" alt="calendar-icon" />
            <h4>Day 3</h4>
            <h3 class="bold inline-block"> Mission-Driven Brands</h3>
            <p class="font-size-18 mt-10"> Brands whose values stand at the center of their business</p>
          </router-link>
        </div>
      </div>
    </div>
    <div class="page-wrapper page-wrapper--white pb-30 pt-30-sm pb-30-sm">
      <div class="container">
        <h4 class="mb-30">Today's Featured Brands</h4>
        <div class="grid-wrapper grid-wrapper--col__4">
          <retailer-tile v-for="(brand, i) in daysData[day]" :key="'brand_' + brand.id + i" :data="brand" />
        </div>
        <div class="container page-wrapper flex justify-center">
          <router-link :to="`/virtual-discovery-show-brand-directory?day=${this.day}`" class="button">
            Shop Today's Brands
          </router-link>
        </div>
      </div>
    </div>

    <div class="container page-wrapper page-wrapper--white pb-30 pt-30-sm pb-30-sm">
      <div class="grid-wrapper grid-wrapper--featured">
        <router-link
          v-for="(feature, i) in featured[this.day - 1]"
          :key="feature.entity_id"
          :to="{ path: feature.link }"
        >
          <div class="imageContainer pointer">
            <div class="overlay pointer" />
            <img alt="collection image" :src="feature.image_url" />
          </div>
          <div>
            <h4 class="mt-30 text-center pointer">
              {{ feature.title }}
            </h4>
            <h1 class="font-size-30 text-center pointer">
              {{ feature.homepage_title }}
            </h1>
          </div>
        </router-link>
      </div>
    </div>
    <div class="page-wrapper pt-0 pb-0">
      <div class="content-container hero-2">
        <h1 class="font-size-38-sm">Join The Conversation</h1>
        <br />
        <h2 class="text-center-sm">Tune in on Zoom, every day at 1pm EST</h2>
        <br />
        <p class="half-width text-center">
          Three panels that are laser-focused on discovery, helping you find the right business partners, and building
          your dream business. You’ll get candid and raw insights from industry experts, plus discover our best-in-class
          brands.
        </p>
        <br />
        <a href="https://bulletin.norby.live/discoveryevent22" target="_blank" class="button black-bg color-white"> RSVP NOW </a>
      </div>
    </div>
    <div class="page-wrapper page-wrapper--white pb-30 pt-30-sm pb-30-sm">
      <div class="container">
        <h4 class="mb-30">best sellers</h4>
        <div>
          <best-sellers />
        </div>
      </div>
    </div>
    <div class="page-wrapper page-wrapper--white pb-30 pt-30-sm pb-30-sm">
      <div class="container">
        <h2 class="text-center" />
        <bulletin-plus :banner="'Check out their posts on The Discovery Feed!'" />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.content-container {
  padding: 7.5% 0;
  display: grid;
  place-items: center;
  background-position: center;
  background-size: cover;

  &.hero-1 {
    background-image: url("~@/assets/img/micro-sites/HERO.png");
  }

  &.hero-2 {
    background-image: url("~@/assets/img/micro-sites/BG.jpg");
  }
}

@import "../../../assets/sass/base/vars.scss";
@import "../../../assets/sass/base/helpers.scss";

.router-link-exact-active {
  h3 {
    background: linear-gradient(to top, #e1ffa1 40%, transparent 50%);
  }
}

.grid-wrapper--featured {
  grid-column-gap: 75px;
  grid-template-columns: 1fr 1fr;
  @include respond-to("small") {
    h4 {
      font-size: 9px;
    }
    h1 {
      font-size: 25px !important;
    }
  }

  .imageContainer {
    position: relative;
  }

  .imageContainer .overlay {
    @include transition;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    visibility: hidden;
    opacity: 0;
    top: 50%;
    z-index: 999;
    pointer-events: none;
  }

  .imageContainer:hover {
    .overlay {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>
<script>
import RetailerTile from "./retailer-tile.vue";
import BrandsData from "@/data/_summerShowcase.json";
import FormAPI from "@/services/api/formApi.js";
import BestSellers from "@/views/home/bestSellers/bestSellers.vue";
import BulletinPlus from "@/views/brandBio/brandPosts/brandPosts.vue";
import Day1 from "@/data/day1.json";
import Day2 from "@/data/day2.json";
import Day3 from "@/data/day3.json";

const FormAPIService = new FormAPI();

export default {
  components: {
    RetailerTile,
    BestSellers,
    BulletinPlus
  },
  data() {
    return {
      daysData: {
        1: this.transform(Day1),
        2: this.transform(Day2),
        3: this.transform(Day3)
      },
      brandList: BrandsData,
      signUpType: "",
      email: "",
      showModal: true,
      showSuccessMessage: false,
      showLoader: false,
      day: 3,
      featured: [
        [
          {
            link: "/exclusive",
            image_url: "https://i.ibb.co/5GsxbJ0/b2401f7c239b18ee9e2d26cc2d2c722b-stocking-42-1.png",
            title: "shop the collection",
            homepage_title: "Exclusive to Bulletin"
          },
          {
            link: "/collection/Exclusive%20Beauty%20&%20Wellness/2667a0db-5fc9-4e5d-ba6c-4a8360cd33f0?page=1",
            image_url: "https://i.ibb.co/xzRRwtT/b2401f7c239b18ee9e2d26cc2d2c722b-stocking-42.png",
            title: "shop the collection",
            homepage_title: "Exclusive Beauty & Wellness"
          }
        ],
        [
          {
            link: "/collection/International%20Brands%20-%202022/7ceb62e1-eb34-49ef-bcd7-5ab20fd27ae5?page=1",
            image_url: "https://i.ibb.co/LzMbFGX/240484442-827908021248504-6737668947023382900-n.jpg",
            title: "shop the collection",
            homepage_title: "International Brands"
          },
          {
            link: "/collection/New%20&%20Trending%202022/a3f4cb6a-da37-4069-bdb8-60652f7f07a5?page=1",
            image_url: "https://bulletin.co/cdn-cgi/image/width=556,quality=100,format=auto/https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/2f9b419e-0f68-4e85-b147-a670561ba6be",
            title: "shop the collection",
            homepage_title: "New & Trending"
          }
        ],
        [
          {
            link: "/collection/Sustainable%20&%20Ethically-Produced%20Brands/51bdd40c-32b0-4da2-a457-91338aea888f?page=1",
            image_url: "https://bulletin.co/cdn-cgi/image/w=560,format=auto/https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/0f961ce9-ed7b-4c2d-86ac-4116bbd633d8",
            title: "shop the collection",
            homepage_title: "Sustainable & Ethically-Produced Brands"
          },
          {
            link: "/collection/Black%20and%20Brown-Owned%20Brands/13d0d025-1670-4676-9c1e-52bcb478d308?page=1",
            image_url: "https://bulletin.co/cdn-cgi/image/w=560,format=auto/https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/61488c77-0c1e-45b0-8c02-b74fcdca1b51",
            title: "shop the collection",
            homepage_title: "Black and Brown-Owned Brands"
          }
        ]
      ]
    };
  },
  watch: {
    $route(to, from) {
      this.day = to.query.day;
    }
  },
  beforeMount() {
    this.$ma.trackEvent({
      action: "View Discovery Landing Page"
    });
    this.showModal = this.determineShowModal();
    if (this.$route.query.day) {
      this.day = this.$route.query.day;
    } else {
      this.$router.replace({
        query: {
          day: 3
        }
      });
    }
  },
  methods: {
    signup,
    apply,
    handleSubmit,
    close,
    determineShowModal,
    transform
  }
};

function transform(data) {
  const temp = data.map((day) => {
    return {
      link: day["Link to Brand Page"],
      name: day["Brand Name"],
      thumbnail_image_url: day["Link to Brand Thumbnail Image"],
      mov: day["MOV"]
      // discount: day.Discount,
      // html: day.Discount.split("\n")
      //   .map((code, i) => {
      //     return `${code} <span class="bold"> ${day["Promo Code"].split("\n")[i]} </span><br/>`;
      //   })
      //   .join(""),
    };
  });
  temp.length = 12;
  return temp;
}

function signup() {
  this.signUpType = "retailer";
}

function apply() {
  this.signUpType = "brand";
}

function close() {
  this.showModal = false;
}

async function handleSubmit() {
  const valid = await this.$validator.validate();
  if (!valid) {
    return;
  }
  this.showLoader = true;
  await FormAPIService.emailCapture({
    emailAddress: this.email,
    type: this.signUpType
  });
  this.showLoader = false;
  this.close();
  localStorage.setItem("QUICK_SIGNUP_SUMMER_SHOWCASE", true);
}

function determineShowModal() {
  const didQuickSignup = localStorage.QUICK_SIGNUP_SUMMER_SHOWCASE === "true",
    isUser = this.$session.getUserInfo() !== null;
  if (isUser) {
    return false;
  }
  if (didQuickSignup) {
    return false;
  }
  return true;
}
</script>
